module.exports = __webpack_public_path__ + "static/media/icono-borrar.b4531569.svg";